import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DOWNLOAD_AD_UNITS_CONFIGURATION: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation downloadAdUnitsConfiguration($input: DownloadAdUnitsXlsInput!) {
    downloadAdUnitsXls(input: $input) {
      fileData

      errors {
        ...ErrorFragment
      }
    }
  }
`
